import  SearchIcon from "./Vector.svg";
import  CrossIcon from "./cross.png";
import  Anatomy from "./anatomy.svg";
import  VideoArrow from "./video_chevron.svg";
import  Micro from "./microbio.svg";
import  Physio from "./Physio.svg";
import  Forensic from "./Forensic.svg";
import  Dna from "./Dna.svg";
import  Optha from "./Optha.svg";
import  Pathalogy from "./pathalogy.svg";
import  Ent from "./Ent.svg";
import  Pharma from "./Pharma.svg";
import  Play from "./play_icon.svg";
import  Star from "./star.svg";
import  Clock from "./clock.svg";
import  Head from "./head.svg";
import  Embryology from "./embryology.svg";
import  Brain from "./brain.svg";
import  Thorax from "./thorax.svg";
import  Abdomen from "./abdomen.svg";
import  Limb from "./limb.svg";
import  Microscope from "./microscope.svg";
import  Osteology from "./osteology.svg";
import  ArrowBlue from "./arrow_blue.svg";
import  TickCircle from "./tick_circle.svg";
import  BackArrow from "./back_arrow.svg";
import  Lock from "./lock.svg";
import  Bookmark from "./bookmarks.svg";
import  unBookmark from "./bookmark.svg";
import  ModalCross from "./modal_cross.svg";
import  ModalWarning from "./modal_warning.svg";
import  QbRightArrow from "./qb_right_arrow.svg";
import  HelpCircle from "./help-circle.svg";
import  ShareBlue from "./share_blue.svg";
import  Instructions from "./instructions.svg";
import  HourGlass from "./hourGlass.svg";
import  BookmarkYellow from "./bookmarkYellow.svg";
import  Delete from "./delet.svg";
import  BookmarkArrow from "./bookmark_arrow.svg";
import  Refresh from "./refresh.svg";
import  Arrowfade from "./arrow_fade.svg";
import  Info from "./info.svg";
import  Timer from "./timer.svg";
import  Maximize from "./Maximize.svg";
import  Copy from "./copy.svg";
import  ListView from "./list_view.svg";
import  GridView from "./grid.svg";
import  ChevRight from "./chev_right.svg";
import  TestArrow from "./test_arrow.svg";
import  RadioWave from "./radio_wave.svg";
import  SliderLeft from "./slider_left.svg";
import  SliderArrow from "./slider_arrow.svg";
import  Test2022 from "./test_2022.svg";
import  Test2021 from "./test_2021.svg";
import  Test2020 from "./test_2020.svg";
import  Test2019 from "./test_2019.svg";
import  TickTest from "./tick_test.svg";
import  Edit from "./edit.svg";
import  Plans from "./plans.svg";
import  Orders from "./orders.svg";
import  AccBookmarks from "./acc_bookmarks.svg";
import  Settings from "./settings.svg";
import  Logout from "./logout.svg";
import  Globe from "./globe.svg";
import  Android from "./android.svg";
import  Camera from "./camera.svg";
import  OrderArrow from "./order_arrow.svg";
import  Mail from "./mail.svg";
import  Phone from "./phone.svg";
import  OrderDetailInfo from "./order_detail_info.svg";
import  ListGridToggle from "./list_grid_toggle.svg";
import  ResultPerc from "./result_perc.svg";
import  ResultAccu from "./result_accu.svg";
import  ResultClock from "./result_clock.svg";
import  ResultMarks from "./result_marks.svg";
import  ResultGraph from "./result_graph.svg";
import  Attempted from "./attempted.svg";
import  Correct from "./correct.svg";
import  Incorrect from "./incorrect.svg";
import  Unanswered from "./unanswered.svg";
import  Guess from "./guess.svg";
import  Reviewed from "./reviewed.svg";
import  SubjectArrow from "./subject_arrow.svg";
import  Filter from "./filter.svg";
import  CloseItem from "./closeItem.svg";
import  Reload from "./reload.svg";
import  ArrWhite from "./arr_white.svg";
import  UserPic from "./user_pic.svg";
import  ArrowLeftBg from "./arrow-leftBg.svg";
import  AddSelect from "./add_select.svg";
import  AddonSelected from "./addon_selected.svg";
import  Apple from "./apple.svg";
import  OrderDropdown from "./orderDropdown.svg";
import  Msg from "./msg.svg";
import  Call from "./call.svg";
import  Whatsapp from "./whatsapp.svg";
import  CheckboxUnfilled from "./checkbox_unfilled.svg";
import  CheckboxFilled from "./checkbox_filled.svg";
import  LockPro from "./lock_pro.svg";
import  Plus_Circle from "./plus-circle.svg";
import QuesPaper from "./TestAttempt.svg";
import ViewInst from "./InfoAttempt.svg";
import Avatar from "./avatar.svg";
import AnsweredMarked from "./answered_marked.svg";
import CrossW from "./cross_w.svg";
import GuessIcon from "./guess_icon.svg";



const Icons = {
    SearchIcon,
    CrossIcon,
    unBookmark,
    Anatomy,
    VideoArrow,
    Micro,
    Physio,
    Forensic,
    Dna,
    Optha,
    Pathalogy,
    Ent,
    Pharma,
    Play,
    Star,
    Clock,
    Head,
    Embryology,
    Brain,
    Thorax,
    Abdomen,
    Limb,
    Microscope,
    Osteology,
    ArrowBlue,
    TickCircle,
    BackArrow,
    Lock,
    Bookmark,
    ModalCross,
    ModalWarning,
    QbRightArrow,
    HelpCircle,
    ShareBlue,
    Instructions,
    HourGlass,
    BookmarkYellow,
    Delete,
    BookmarkArrow,
    Refresh,
    Arrowfade,
    Info,
    Timer,
    Maximize,
    Copy,
    ListView,
    GridView,
    ChevRight,
    TestArrow,
    RadioWave,
    SliderLeft,
    SliderArrow,
    Test2022,
    Test2021,
    Test2020,
    Test2019,
    TickTest,
    Edit,
    Plans,
    Orders,
    AccBookmarks,
    Settings,
    Logout,
    Globe,
    Android,
    Camera,
    OrderArrow,
    Mail,
    Phone,
    OrderDetailInfo,
    ListGridToggle,
    ResultPerc,
    ResultAccu,
    ResultClock,
    ResultMarks,
    ResultGraph,
    Attempted,
    Correct,
    Incorrect,
    Unanswered,
    Guess,
    Reviewed,
    SubjectArrow,
    Filter,
    CloseItem,
    Reload,
    ArrWhite,
    UserPic,
    ArrowLeftBg,
    AddSelect,
    AddonSelected,
    Apple,
    OrderDropdown,
    Msg,
    Call,
    Whatsapp,
    CheckboxUnfilled,
    CheckboxFilled,
    LockPro,
    Plus_Circle,
    QuesPaper,
    ViewInst,
    Avatar,
    AnsweredMarked,
    CrossW,
    GuessIcon
}

export default Icons;